import { reportError } from "../appsignal";

type ProcessingCheckProps = {
  statusUrl: string,
  completedUrl: string,
  failedUrl: string,
};

type ProcessingStatus = {
  redirectUrl: string | null,
  status: string,
};

export default function subscriptionProcessing(_el: HTMLElement, props: ProcessingCheckProps) {
  pollStatus();

  function handleStatus(response: ProcessingStatus): boolean {
    if (response.redirectUrl) {
      window.location.href = response.redirectUrl;
      return true;
    } else if (response.status === "completed") {
      window.location.href = props.completedUrl;
      return true;
    } else if (response.status === "failed") {
      window.location.href = props.failedUrl;
      return true;
    }

    return false;
  }

  async function pollStatus() {
    try {
      const status = await fetchStatus();
      if (status) {
        if (handleStatus(status)) {
          return;
        }
      }
    } catch (err) {
      reportError(err);
    }

    // always re-poll by default
    window.setTimeout(pollStatus, 5000);
  }

  async function fetchStatus(): Promise<ProcessingStatus | null> {
    const response = await fetch(props.statusUrl, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        accept: "application/json"
      }
    });

    if (!response.ok) {
      return null;
    }

    return await response.json();
  }
}
